export const MAX_INVITEE_COUNT = 30;
